import {Student} from '@esgi/main/libs/store';
import {createContext} from '@esgi/ui';

export type StudentContextValue = {
	students: Student[],
	selectedStudentIDs: number[],
	setSelectedStudentID: (id: number) => void,
}

export const {Context, useHook: useStudentContext} = createContext<StudentContextValue>('StudentContext');